import { Spinner } from "@fluentui/react-components";

export default function OiLoadingSpinner() {
    return (
        <div className="flex h-screen w-full flex-1 items-center justify-center pb-4 animate-fade-in">
            <Spinner />
        </div>
    );
}
